module.exports = __webpack_public_path__ + "img/AK0092-WB.84f6b9a4.jpg";